import { getUniqueSymbol } from './symbolWithExchange';
import dbee from '@os/dbee';

/**
 * See {@link dbee.static-app.apla.dev.opal.synacor.com|@os/dbee Documentation}
 * <p>dbee storage for caching CloudQuote API response data</p>
 * @module util/storage
 */

/**
 * dbee instance for storing responses to fetch calls
 * @memberof util/storage
 */
export const fetchCache = dbee('cloudquote.requests', { adapter: 'sessionStorage' });

/**
 * dbee instance for storing symbols found across all response
 * @memberof util/storage
 */
export const symbolCache = dbee('cloudquote.symbols', { adapter: 'memory' });

export function safeSetSymbolCache(row, when) {
	try {
		symbolCache.set(
			row.UniqueSymbol,
			{ ...row, cacheTime: when }
		);
	}
	catch (e) {
		console.error(e);
	}
}

export const addUniqueSymbol = data => {
	if (data && data.rows === undefined) {
		//Single row
		let composite = getUniqueSymbol(data);
		data.UniqueSymbol = composite;
	}
	else if (data !== null){
		//many rows
		data.rows.forEach((row) => {
			let composite = getUniqueSymbol(row);
			row.UniqueSymbol = composite;
		});
	}

	return data;
};

/**
 * If a response sends back Symbols, store them in a symbol cache
 * @private
 * @param {Object} data     response from CloudQuote API containing stock quotes
 * @returns {Promise}       passes through the data that was passed in
 * @memberof CloudQuote
 */
export function symbolCacheStoreResult(data) {
	if (data && data.rows) {
		let now = Date.now();

		data.rows.forEach((row) => {
			//Add UniqueSymbol to the row
			if (row) {
				row = addUniqueSymbol(row);
			}

			// TODO: How much overhead for accessing all the data on every request like this?
			// if the row contains a Symbol, add it to the cache
			if (row && row.UniqueSymbol) {
				safeSetSymbolCache(row, now);
			}
		});

	}
	return Promise.resolve(data);
}

/**
 * Get a list of symbols from the symbol cache
 * <p> TODO: Create caching accross-endpoints by always trying to grab from symbolCache first</p>
 * @function getQuotesFromSymbolCache
 * @param {String|String[]} symbols      a symbol or array of symbols
 * @returns {(Object|undefined)[]}       for each symbol in symbols, return either the symbol quote from cache or undefined if not in cache
 * @memberof CloudQuote
 */
export function getQuotesFromSymbolCache(symbols) {
	const expiry = 20; // dont accept cache hits that are more than 20 seconds old
	symbols = [].concat(symbols);
	let rows = symbols.map((uniqueSymbols = '') => {
		let cached = symbolCache.get(uniqueSymbols);
		if (cached) {
			let age = (Date.now() - cached.cacheTime) / 1000;
			if (age < expiry) {
				return cached;
			}

			symbolCache.remove(uniqueSymbols);
		}
	});

	// Return result rows as they were found in the cache, and return a list of symbols not found in the cache.
	return {
		results: { rows },
		miss: symbols.filter((_, index) => !rows[index])
	};
}



// WEBPACK FOOTER //
// ../node_modules/@os/cloudquote/src/util/storage.js